var _rect, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCommercialEmergencyExit = function SvgCommercialEmergencyExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 22H32v76h56V22z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28H38v70h44V28z",
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    d: "M38 62h44v6H38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    d: "M54 62h24v6H54z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF9DC",
    stroke: "#332C4A",
    strokeWidth: 2,
    d: "M48 42h24v6H48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    d: "M82 59h6v12h-6z"
  })));
};

export default SvgCommercialEmergencyExit;